import { message } from 'antd'
import {
  getClubAllShift,
  getChargeTypeList,
  getSalaryTypeList,
  getClubStaffList,
  getStaffDetails,
  addOrEditEmployee,
  deleteEmployee,
} from '../../api/employee'
import {
  getAllTemplateList,
  addOrEditPermissionTemplate,
  getTemplateDetail,
} from '../../api/permissionTemplate'
import {
  UPDATE_CEM_TABLE_LIST,
  UPDATE_CEM_SHIFT_LIST,
  UPDATE_CEM_TEMPLATE_LIST,
  UPDATE_CEM_CHARGE_LIST,
  UPDATE_CEM_SALARY_LIST,
} from './constants'

// 获取员工列表
export function getStaffList() {
  return async (dispatch, getState) => {
    const res = await getClubStaffList()
    const { status, detail, data } = res
    if (status != 1) {
      message.error(detail)
      dispatch(update_table_list([]))
    } else {
      dispatch(update_table_list(data))
    }
    return res
  }
}

// 获取当前俱乐部所有班次
export function getShiftList() {
  return async (dispatch, getState) => {
    const res = await getClubAllShift()
    const { status, detail, data } = res
    if (status != 1) {
      message.error(detail)
      dispatch(update_shift_list([]))
    } else {
      const newAry = data.map((item) => {
        return {
          label: item.name,
          value: item.id,
        }
      })
      dispatch(update_shift_list(newAry))
    }
    return res
  }
}

// 获取所有模板包含联盟的
export function allTemplateList() {
  return async (dispatch, getState) => {
    const res = await getAllTemplateList()
    const { status, detail, data } = res
    if (status != 1) {
      message.error(detail)
      dispatch(update_template_list([]))
    } else {
      const newAry = data.map((item) => {
        return {
          label: item.name,
          value: item.id,
        }
      })
      dispatch(update_template_list(newAry))
    }
    return res
  }
}

// 获取收费类型
export function chargeTypeList() {
  return async (dispatch, getState) => {
    const res = await getChargeTypeList()
    const { status, detail, data } = res
    if (status != 1) {
      message.error(detail)
      dispatch(update_charge_list([]))
    } else {
      const newAry = data.map((item) => {
        return {
          label: item.description,
          value: item.value,
        }
      })
      dispatch(update_charge_list(newAry))
    }
    return res
  }
}

// 获取薪酬类型
export function salaryTypeList() {
  return async (dispatch, getState) => {
    const res = await getSalaryTypeList()
    const { status, detail, data } = res
    if (status != 1) {
      message.error(detail)
      dispatch(update_salary_list([]))
    } else {
      const newAry = data.map((item) => {
        return {
          label: item.description,
          value: item.value,
        }
      })
      dispatch(update_salary_list(newAry))
    }
    return res
  }
}

// 获取员工详情
export function getStaffDetail(id) {
  return async (dispatch, getState) => {
    const res = await getStaffDetails(id)
    const { status, detail, data } = res
    if (status != 1) {
      message.error(detail)
      return null
    }
    return data
  }
}

// 保存模板
export function saveEmployeeTemplate(data) {
  return async (dispatch, getState) => {
    const res = await addOrEditPermissionTemplate(data)
    const { status, detail } = res
    if (status != 1) {
      message.error(detail)
    } else {
      message.success('保存模板成功')
      dispatch(allTemplateList())
    }
    return res
  }
}

// 获取模板详情
export function obtainTemplateDetail(id) {
  return async (dispatch, getState) => {
    const res = await getTemplateDetail(id)
    const { status, detail, data } = res
    if (status != 1) {
      message.error(detail)
      return null
    }
    return data
  }
}

// 新增或修改用户权限（新增员工）
export function postEmployeeDetail(data) {
  return async (dispatch, getState) => {
    const res = await addOrEditEmployee(data)
    const { status, detail } = res
    if (status != 1) {
      message.error(detail)
      return false
    }
    message.success('操作成功')
    dispatch(getStaffList())
    return true
  }
}

// 删除员工
export function postDeleteEmployee(id) {
  return async (dispatch, getState) => {
    const res = await deleteEmployee(id)
    const { status, detail } = res
    if (status != 1) {
      message.error(detail)
    } else {
      message.success('删除成功')
      dispatch(getStaffList())
    }
    return res
  }
}

export const update_table_list = (payload) => {
  return {
    type: UPDATE_CEM_TABLE_LIST,
    payload,
  }
}

export const update_shift_list = (payload) => {
  return {
    type: UPDATE_CEM_SHIFT_LIST,
    payload,
  }
}

export const update_template_list = (payload) => {
  return {
    type: UPDATE_CEM_TEMPLATE_LIST,
    payload,
  }
}

export const update_charge_list = (payload) => {
  return {
    type: UPDATE_CEM_CHARGE_LIST,
    payload,
  }
}

export const update_salary_list = (payload) => {
  return {
    type: UPDATE_CEM_SALARY_LIST,
    payload,
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubEmployeeManager/action.js